import React from "react"
import SbEditable from "storyblok-react"
import { S22Modal } from "./Modal"
import { StaticQuery, graphql } from "gatsby"
import _ from "lodash"
import { S22ModalContent } from "./ModalContent"

export const S22ModalReference: React.FC = ({
  reference,
  blok,
  onClick,
  visible,
  prevModal,
  nextModal,
  disbableNext,
  disbablePrev,
  noOfCards,
}) => (
  <>
  <StaticQuery
    query={graphql`
      query {
        allStoryblokEntry(
          filter: { full_slug: { regex: "/^hult/config/modals/" } }
        ) {
          edges {
            node {
              uuid
              content
            }
          }
        }
      }
    `}
    render={(data) => {
      let cmp: any
      if (data && data.allStoryblokEntry) {
        data.allStoryblokEntry.edges.filter((e) => {
          if (e.node.uuid === reference) {
            const block = JSON.parse(e.node.content)
            return (cmp = (
              <SbEditable content={blok}>
                <S22ModalContent
                  key={e.node.uuid}
                  blok={block}
                  onClick={onClick}
                  visible={visible}
                  prevModal={prevModal}
                  nextModal={nextModal}
                  disbableNext={disbableNext}
                  disbablePrev={disbablePrev}
                  noOfCards={noOfCards}
                  // accent_color={accent_color}
                />
              </SbEditable>
            ))
          }
          return cmp
        })
      }
      return cmp
    }}
  />
  </>
)
